<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q2JxpF/tc-custom/9780061748714.jpg?1718106014746" alt="This image is the cover for the book Lost in the City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost in the City
      </h1>
      <p class="bookDescription body article font2">
        <b>Fourteen poignant stories depicting African American life in Washington, D.C., by the Pulitzer Prize–winning author of <i>The Known World</i>.</b><br/><br/>The nation’s capital that serves as the setting for the stories in Edward P. Jones’s prize-winning collection, <i>Lost in the City</i>, lies far from the city of historic monuments and national politicians. Jones takes the reader beyond that world into the lives of African American men and women who work against the constant threat of loss to maintain a sense of hope. From “The Girl Who Raised Pigeons” to the well-to-do career woman awakened in the night by a phone call that will take her on a journey back to the past, the characters in these stories forge bonds of community as they struggle against the limits of their city to stave off the loss of family, friends, memories, and, ultimately, themselves.<br/><br/>Critically acclaimed upon publication, <i>Lost in the City</i> introduced Jones as an undeniable talent, a writer whose unaffected style is not only evocative and forceful but also filled with insight and poignancy.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward P. Jones
      </h2>
      
      <p class="authorDescription body article"><P>Edward P. Jones, the <I>New York Times</I> bestselling author, has been awarded the Pulitzer Prize, for fiction, the National Book Critics Circle award, the International IMPAC Dublin Literary Award, and the Lannan Literary Award for <I>The Known World;</I> he also received a MacArthur Fellowship in 2004. His first collection of stories, <I>Lost in the City,</I> won the PEN/Hemingway Award and was short listed for the National Book Award. His second collection, <I>All Aunt Hagar&#8217;s Children, </I>was a finalist for the Pen/Faulkner Award. He has been an instructor of fiction writing at a range of universities, including Princeton. He lives in Washington, D.C.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00a8463c